import { render, staticRenderFns } from "./SnoozeAlertModal.vue?vue&type=template&id=3260cba6&scoped=true&"
import script from "./SnoozeAlertModal.vue?vue&type=script&lang=js&"
export * from "./SnoozeAlertModal.vue?vue&type=script&lang=js&"
import style0 from "./SnoozeAlertModal.vue?vue&type=style&index=0&id=3260cba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3260cba6",
  null
  
)

export default component.exports